export default __webpack_public_path__ + "static/media/Icon-Chevron-Down-Green.9eee4d0c.svg";